export const isDemo = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("demo") === "1";
};
